<template>
  <!-- 街道报表 -->
  <div class="search_wrap">
    <el-form
      :model="queryParam"
      ref="form"
      label-width="80px"
      :inline="true"
      size="mini"
    >
        <el-form-item label="街道">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.wlStreetName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      <div class="selectBox">
        <span class="selectText">巡检日期</span>
        <el-date-picker
          size="mini"
          v-model="inspectionDate"
          @change="dateChange"
          :default-value="dateDefaultShow"
          unlink-panels
          :clearable="false"
          :picker-options="expireTimeOption"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
    </el-form>
      <!-- <downloadExcel
      class="export-excel-wrapper"
      :data="dataSource"
      :fields="json_fields"
      :header="title"
      name="社区报表.xls">
      <el-button type="success">导出</el-button>
    </downloadExcel> -->
      <e-table
        :listLoading="loading"
        :selection="true"
        :tableHeadConfig="columns"
        @pageChange="loadData"
        :paginationData="ipagination"
        :tableLoadData="dataSource"
        @selectLine="onSelectChange"
        :tableRowClassName="tableRowClassName"
      >
        <template #timeScope="slotData">
          {{
            slotData.data.row.inspectionDateStart
              ? slotData.data.row.inspectionDateStart.split(" ")[0]
              : "暂无"
          }}
          -
          {{
            slotData.data.row.inspectionDateEnd
              ? slotData.data.row.inspectionDateEnd.split(" ")[0]
              : "暂无"
          }}
        </template>
      </e-table>
  </div>
</template>

<script>
let noSearch = 1
// import downloadExcel from 'vue-json-excel'
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import {
  postAction,
  getAction,
} from '@/api/manage';
export default {
  // components: {eTable, downloadExcel},
  components: { eTable },
  mixins: [listMixin],
  beforeMount () {
    noSearch = null
  },
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  data() {
    return {
      inspectionDate: '',
      dateDefaultShow: '',
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        }
      },
      queryParam: {
        wlStreetName: ''
      },
      url: {
        list: "/inspectionStatistics/streetStatistics",
      },
      columns: [
        { field: "wlStreetName", label: "街道" },
        { field: "inspectionCommunityNum", label: "巡检小区数量" },
        { field: "inspectionNum", label: "巡检桶站数量" },
        {
          width: 260,
          label: "巡检日期范围",
          slotName: "timeScope",
          columnType: "slot",
        },
        // { field: "inspectionDate", label: "巡检统计日期" },
        { field: "onDutyRate", label: "在岗率" },
        { field: "onTidyRate", label: "整洁率" },
        { field: "isPureRate", label: "纯净率" },
        { field: "punishmentNum", label: "处罚次数" },
        { field: "punishmentRate", label: "处罚率" },
        { field: "punishmentAmount", label: "处罚总金额" },
        // {
        //   width: 200,
        //   label: "信息",
        //   slotName: "handlerSlot",
        //   columnType: "slot",
        // },
      ],
      // excel属性
      title: "社区报表",
      json_fields: {
        街道: "wlStreetName",
        巡检小区数量: "inspectionCommunityNum",
        巡检桶站数量: "inspectionNum",
        // "巡检统计日期": "inspectionDate",
        在岗率: "onDutyRate",
        整洁率: "onTidyRate",
        纯净率: "isPureRate",
        处罚次数: "punishmentNum",
        处罚率: "punishmentRate",
        处罚总金额: "punishmentAmount",
      },
    };
  },
  // updated () {
  //   this.dataSource.forEach(item => {
  //     let itemDate = item.inspectionDate.split(' ')
  //     item.inspectionDateStart = itemDate[0]
  //   });
  // },
  methods: {
    loadData (arg) {
      if (noSearch === 1) {
        console.log('before,初次进入不搜索');
        return;
      }
      if (!this.inspectionDate) {
        this.$message.warning('请选择日期,并且巡检日期相差不能超过92天');
        return;
      }
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams(); //查询条件
      this.loading = true;

      if (this.loadOtherData) {
        this.loadOtherData(params);
      }
      if (!this.loadWithGet) {
        postAction(this.url.list, params).then((res) => {
          if (res.msg) {
            this.$message.warning(res.msg);
            this.loading = false;
            return;
          }
          // if (res.code==200) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          this.dataSource =
            res?.result?.records || res?.result || res.data.records;
          if (res.data.total) {
            this.ipagination.total = res.data.total;
          } else {
            this.ipagination.total = 0;
          }
          //update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          // }

          this.loading = false;
        });
      } else {
        getAction(this.url.list, params).then((res) => {
          if (res.msg) {
            this.$message.warning(res.msg);
            return;
          }
          // if (res.code==200) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          this.dataSource =
            res?.data ||
            res?.result?.records ||
            res?.result ||
            res.data.records;
          if (res.data.total) {
            this.ipagination.total = res.data.total;
          } else {
            this.ipagination.total = 0;
          }
          //update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          // }

          this.loading = false;
        });
      }
    },
    dateChange (date) {
      this.queryParam.dateStart = date[0] + ' 00:00:00'
      this.queryParam.dateEnd = date[1] + ' 23:59:59'
    },
    resetForm () {
      this.queryParam = {
        wlStreetName: ''
      }
      this.inspectionDate = ''
      // this.searchQuery()
    },
    // getInfo (val) {
    //   console.log(val);
    
    // },
  },
};
</script>

<style scoped lang="scss">
.search_wrap {
  margin: 10px 0;
}
.imgBox {
  width: 150;
  height: 150px;
  border: 1px solid rgb(223, 212, 212);
}

.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}

.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>